var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_REPORTS = 'api/reports';
const GET_SET_STATISTICS = 'api/statistics';
export const getFinancialSummary = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr(['fromDate', 'toDate'], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${params.storeId}/financial-summary${queryParams ? `?${queryParams}` : ''}`, config);
        }
        catch (error) {
            console.error('Error fetching getFinancialSummary:', error);
            throw error;
        }
    });
};
export const getCleanedOrdersReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'pageNum',
                'limit',
                'timezone',
                'includeGraph',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/cleaned-orders?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getCleanedOrdersReport:', error);
            throw error;
        }
    });
};
export const getCleanedOrdersGraphDataReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/cleaned-orders-graph?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getCleanedOrdersGraphDataReport :', error);
            throw error;
        }
    });
};
export const getSalesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
                'type',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/sales?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getSalesReport:', error);
            throw error;
        }
    });
};
export const getCustomersReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'fromDate',
                'toDate',
                'sortBy',
                'sortOrder',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/customers?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getCustomersReport:', error);
            throw error;
        }
    });
};
export const getSuppliesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'fromDate',
                'toDate',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/supplies?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getSuppliesReport:', error);
            throw error;
        }
    });
};
export const getDiscountCodesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/discountCodes?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getDiscountCodesReport:', error);
            throw error;
        }
    });
};
export const getStaffReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'fromDate',
                'toDate',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/staff?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getStaffReport:', error);
            throw error;
        }
    });
};
export const getStaffActivityDetails = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'employeeId',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/staff/details?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getStaffActivityDetails:', error);
            throw error;
        }
    });
};
export const getProductSalesReport = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
                'groupBySection',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/productSales?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getProductSalesReport:', error);
            throw error;
        }
    });
};
export const getProductSalesDrillDown = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeProductId',
                'fromDate',
                'toDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/productSales/drill-down?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getProductSalesDrillDown:', error);
            throw error;
        }
    });
};
export const getPaymentLinesReport = function (storeId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, options), { headers: { Authorization: `Bearer ${this.apiToken}` } });
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'pageNum',
                'limit',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/paymentLines?${queryParams}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const getCashierBoxMovementsReport = function (storeId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, options), { headers: { Authorization: `Bearer ${this.apiToken}` } });
            const queryParams = generateQueryParamsStr([
                'cashierBoxId',
                'fromDate',
                'toDate',
                'pageNum',
                'limit',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/cashierBoxMovements?${queryParams}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const getSupplyCostReport = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'store',
                'fromDate',
                'toDate',
                'supplyId',
                'productId',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/supply-cost?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getSupplyCostReport:', error);
            throw error;
        }
    });
};
export const exportSupplyCostReport = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${this.apiToken}`,
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'Content-disposition': 'attachment; filename=[file.csv]'
                },
                params: {
                    responseType: 'blob'
                }
            };
            const queryParams = generateQueryParamsStr([
                'store',
                'fromDate',
                'toDate',
                'supplyId',
                'productId',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/supply-cost/export?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching exportSupplyCostReport:', error);
            throw error;
        }
    });
};
export const getUnpaidOrdersReport = function (storeId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = Object.assign(Object.assign({}, options), { headers: { Authorization: `Bearer ${this.apiToken}` } });
        const queryParams = generateQueryParamsStr([
            'fromDate',
            'toDate',
            'pageNum',
            'limit',
            'timezone',
            'customerName'
        ], params);
        return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/unpaidOrders?${queryParams}`, config);
    });
};
export const getAnnualSalesStatistics = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_STATISTICS}/${storeId}/annual?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getAnnualSalesStatistics :', error);
            throw error;
        }
    });
};
export const getPaymentMethodStatistics = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_STATISTICS}/${storeId}/ordersPaymentMethod?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getPaymentMethodStatistics :', error);
            throw error;
        }
    });
};
export const getProductsStatistics = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_STATISTICS}/${storeId}/ordersProduct?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getProductsStatistics :', error);
            throw error;
        }
    });
};
export const getMonthSalesStatistics = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_STATISTICS}/${storeId}/month?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getMonthSalesStatistics :', error);
            throw error;
        }
    });
};
export const getPopularDaysStatistics = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'toDate',
                'fromDate',
                'timezone',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_STATISTICS}/${storeId}/popularDays?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getPopularDaysStatistics :', error);
            throw error;
        }
    });
};
export const getCashUpReportsByDateRange = function (storeId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'fromDate',
                'toDate',
                'cashierBoxId',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${storeId}/cashups?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getCashUpReportsByDateRange:', error);
            throw error;
        }
    });
};
export const getScheduledDeliveries = function (companyId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'dateFrom',
                'dateTo',
                'includeDelivered',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${companyId}/scheduledDeliveries?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getScheduledDeliveries:', error);
            throw error;
        }
    });
};
export const getServicesToDeliver = function (companyId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'storeId',
                'dateFrom',
                'dateTo',
                'hideReady',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${companyId}/servicesToDeliver?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getServicesToDeliver:', error);
            throw error;
        }
    });
};
export const getOrdersHistoryReport = function (companyId, params, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = Object.assign(Object.assign({}, options), { headers: { Authorization: `Bearer ${this.apiToken}` } });
            const queryParams = generateQueryParamsStr([
                'storeId',
                'dateField',
                'dateFrom',
                'dateTo',
                'statuses',
                'sequence',
                'homeServiceOnly',
                'page',
                'limit',
                'sortDirection',
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_REPORTS}/${companyId}/ordersHistory?${queryParams}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
